export default __webpack_public_path__ + "static/media/element_95.e09c558c.jpg";